import React from 'react';
import styled from 'styled-components';
import FormTitle from '../molecules/FormTitle';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { SOFT_TOMATO } from '../../colors';

interface PaymentProps {
  isFormValid: boolean;
  paypalExpressAmount: number;
  onPress: (method: string) => void;
  onExpressCheckout: (transactionId: string) => void;
}

const Payment = ({
  isFormValid = false,
  onPress,
  paypalExpressAmount = 0,
  onExpressCheckout
}: PaymentProps) => {
  return (
    <>
      <Form>
        <FormTitle title={'PAYMENT METHODS'} />
        <ExpressCheckout>
          <p>
            <strong>
              {`PayPal Fee Notice: A 4.4% processing fee applies, plus a fixed fee of ₱15 for Philippine transactions or ₱18 for international payments.`.toUpperCase()}
            </strong>
          </p>
          <p>
            {`After clicking “Pay now”, you will be redirected to PayPal.com in order to complete your purchase securely.`.toUpperCase()}
          </p>
          <PayPalScriptProvider options={{ 
              clientId: 'AZO-S2RA9bp7_IpCe6SKX_75A7EiH2f1KTv_LyS-5_HxIufbBkJp9ieqqGUUj71OkcNMweNaKt0ZSxsy', 
              currency: 'PHP',
            }}
          >
            <PayPalButtons 
              disabled={!isFormValid}
              forceReRender={[paypalExpressAmount]} 
              style={{ layout: "horizontal" }}
              createOrder={(data, actions) => {
                console.log("Amount:", paypalExpressAmount, paypalExpressAmount.toFixed(2)); 
                return actions.order.create({
                  intent: "CAPTURE",
                  purchase_units: [
                    {
                      amount: {
                        currency_code: "PHP",
                        value: String(paypalExpressAmount.toFixed(2)) // Ensure this is a string with two decimals
                      },
                    },
                  ],
                });
              }}
              onApprove={(data, actions) => {
                if (!actions.order) {
                  return Promise.reject('error');
                }
                return actions.order.capture().then((details) => {
                  // const payerName = details?.payer?.name?.given_name || "Customer";
                  // const transactionId = details?.id;
                  
                  // console.log("✅ Payment successful");
                  // console.log("🧾 Transaction ID:", transactionId);
                  // console.log("👤 Paid by:", payerName);
                  // console.log("💵 Amount:", details?.purchase_units?.[0]?.amount?.value, details?.purchase_units?.[0]?.amount?.currency_code);

                  // Optional: Send details to your backend
                  // fetch('/api/save-order', { method: 'POST', body: JSON.stringify(details) });

                  // alert(`Payment completed by ${payerName}`);
                  console.log('✅ Payment details:', details); // <--- ADD THIS
                  onExpressCheckout(details?.id || '');
                });
              }}
              onError={(err) => {
                console.error("PayPal Checkout Error:", err);
              }}
              
            />
          </PayPalScriptProvider>
        </ExpressCheckout>
        <DividerContainer>
          <Line />
          <Text>OR</Text>
          <Line />
        </DividerContainer>
        <CompleteOrder>
          <p>
            <strong>
            {`Free cash on delivery for Metro Manila. For provincial or other locations, Our staff will contact you for order confirmation.`.toUpperCase()}
            </strong>
          </p>
          <button
            disabled={!isFormValid}
            onClick={() => onPress('Cash on Delivery')}
          >
            CASH ON DELIVERY
          </button>
        </CompleteOrder>
        <DividerContainer>
          <Line />
          <Text>OR</Text>
          <Line />
        </DividerContainer>
        <CompleteOrder>
          <p>
            <strong>
            {`Connect with us via Facebook messager, Instagram, viber(+639173225673) and whatsapp(+639173225673) to process your orders.`.toUpperCase()}
            </strong>
          </p>
          <button
            disabled={!isFormValid}
            onClick={() => onPress('')}
          >
            SUBMIT ORDER
          </button>
        </CompleteOrder>
      </Form>
    </>
  )
}

const Form = styled.div`
  padding: 0.5rem 0rem;
`;

const ExpressCheckout = styled.div`
  padding: 0.5rem 0rem;
  p {
    margin: 0 0;
    margin-bottom: 0.5rem;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
  }
`;

const CompleteOrder = styled.div`
  button {
    width: 100%;
    border: none;
    background-color: ${SOFT_TOMATO};
    color: white;
    border-radius: 6px;
    height: 40px;
    font-family: 'Poppins-SemiBold';
    font-size: 0.8rem;

    &:disabled {
      background-color: #cccccc;
      cursor: not-allowed;
      color: #666;
    }
  };

  p {
    margin: 0 0;
    margin-bottom: 0.5rem;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
  }
`;

const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
`;

const Line = styled.div`
  flex: 1;
  height: 1px;
  background-color: #ccc;
`;

const Text = styled.span`
  margin: 0 0.75rem;
  color: #666;
  white-space: nowrap;
  font-family: 'Poppins-SemiBold';
  font-size: 0.8rem;
`;

export default Payment;
